import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { serviceStore } from "../../../actions/serviceAction";
import { connect, useSelector } from "react-redux";

const ServiceStep3Page = ({ serviceStore }) => {
  const service = useSelector((state) => state.service);

  const [serviceName, setServiceName] = useState(service.serviceData["serviceName"] || "");
  const [serviceTellUs, setServiceTellUs] = useState(service.serviceData["serviceTellUs"] || "");
  const [serviceType, setServiceType] = useState(service.serviceData["serviceType"] || "virtual");
  const [rate, setRate] = useState(service.serviceData["serviceRate"] || "");

  const curRef = useRef(null);

  const handleNameChange = (val) => {
    setServiceName(val);
    serviceStore({ num: 1, name: val, flag: false });
  };

  const handleDescChange = (val) => {
    setServiceTellUs(val);
    serviceStore({ num: 2, tellUs: val, type: serviceType, flag: false });
  };

  const handleTypeChange = (val) => {
    setServiceType(val);
    serviceStore({ num: 2, tellUs: serviceTellUs, type: val, flag: false });
  };

  const handleRateChange = (val) => {
    setRate(val);
    serviceStore({ num: 3, rate: val, rateUs: serviceTellUs, flag: false });
  };

  return (
    <div>
      {/* Service Name */}
      <p className="service-text-service mb-2 leading-none">
        What's one service would you like to offer?
      </p>
      <p className="service-text mb-1">
        (i.e. Massage Therapy, Tax Preparation, Photography)
      </p>
      <div className="form-group mt-3 mb-5">
        <input
          type="text"
          className="form-control !py-4 mt-1 border-none rounded-[13px]"
          placeholder="Service Name"
          value={serviceName}
          onChange={(e) => handleNameChange(e.target.value)}
        />
      </div>

      {/* Description */}
      <p className="service-text-label font-semibold mb-1">
        Brief description of the service you're offering:
      </p>
      <div className="form-group mb-5">
        <textarea
          className="form form-control mt-[5px] border-none rounded-[13px]"
          placeholder="Enter here"
          rows={4}
          value={serviceTellUs}
          onChange={(e) => handleDescChange(e.target.value)}
        />
      </div>

      {/* Points / Rate */}
      <div className="flex items-center gap-2 mb-1">
        <p className="service-text-label font-semibold">
          How many points are you asking for this service?
        </p>
        <Link
          to="/how-it-works"
          target="_blank"
          className="text-main text-xs underline whitespace-nowrap"
        >
          How it Works
        </Link>
      </div>
      <div className="sm:relative mb-5">
        <input
          type="number"
          name="points_rate"
          min={0}
          value={rate || ""}
          readOnly
          placeholder="Select a rate"
          className="w-full h-12 pl-4 border border-solid border-[#e9e9e9] outline-none rounded-[13px]"
          style={{ MozAppearance: "textfield" }}
          ref={curRef}
        />
        {/* On mobile the pills stack below the input so they don't overlap the
            placeholder; on sm+ screens they overlay the right of the input. */}
        <div className="flex flex-wrap justify-end gap-2.5 mt-2 sm:mt-0 sm:absolute sm:top-1.5 sm:right-2">
          {[5, 10, 15, 20].map((val) => (
            <button
              key={val}
              type="button"
              onClick={() => handleRateChange(val)}
              className={`px-4 sm:px-5 py-2 border border-solid rounded-full cursor-pointer transition-colors
                ${Number(rate) === val
                  ? "bg-[#1CC300] text-white border-[#1CC300]"
                  : "bg-transparent text-[#1CC300] border-[#1CC300] hover:bg-[#1CC300]/10"
                }`}
            >
              {val}
            </button>
          ))}
        </div>
      </div>

      {/* Virtual / In-Person / Both */}
      <div className="form-group mb-4 flex items-center text-lg">
        <input
          type="radio"
          name="service_type"
          className="mr-1"
          value="virtual"
          onChange={(e) => handleTypeChange(e.target.value)}
          checked={serviceType === "virtual"}
        />
        <span className="mr-8">Virtual</span>
        <input
          type="radio"
          name="service_type"
          className="mr-1"
          value="in-person"
          onChange={(e) => handleTypeChange(e.target.value)}
          checked={serviceType === "in-person"}
        />
        <span className="mr-8">In Person</span>
        <input
          type="radio"
          name="service_type"
          className="mr-1"
          value="both"
          onChange={(e) => handleTypeChange(e.target.value)}
          checked={serviceType === "both"}
        />
        <span>Both</span>
      </div>

      <p className="text-[15px] text-gray-500 italic text-center mt-6 mb-1">
        You can add additional services and more details later.
      </p>
    </div>
  );
};

const mapStateToProps = (state) => ({
  service: state.service,
});
export default connect(mapStateToProps, { serviceStore })(ServiceStep3Page);
